import { useState } from 'react';

export const useCelebration = () => {
  const [showCelebration, setShowCelebration] = useState(false);

  const triggerCelebration = () => {
    setShowCelebration(true);
    
    // Auto-dismiss celebration after 4 seconds
    setTimeout(() => {
      setShowCelebration(false);
    }, 4000);
  };

  const dismissCelebration = () => {
    setShowCelebration(false);
  };

  return {
    showCelebration,
    triggerCelebration,
    dismissCelebration
  };
}; 